import { Translate } from "components/common/Translate/Translate";
import { useBulkResizerDimensionTypes } from "./useBulkResizerDimensionTypes";

export const DimensionTypes = () => {
    const { handleClick, dimensionType } = useBulkResizerDimensionTypes();

    return (
        <div>
            <div className="cursor-pointer flex items-center gap-4 py-1 justify-between rounded-lg bg-irGray-200 dark:bg-darkSurface-300 text-slate-600 dark:text-white font-semibold capitalize my-8 whitespace-nowrap px-1">
                <div
                    data-testid="bulk-resizer-by-dimensions-selector"
                    className={`py-2 flex-grow text-center ${
                        dimensionType === "pixels"
                            ? "bg-white dark:bg-darkSurface-200 text-black rounded-lg"
                            : "text-irGray-600"
                    } dark:text-white`}
                    onClick={() => handleClick("pixels")}
                >
                    <Translate keyName="by-dimensions" />
                </div>
                <div
                    data-testid="bulk-resizer-as-percentage-selector"
                    className={`py-2 flex-grow text-center ${
                        dimensionType === "percentage"
                            ? "bg-white dark:bg-darkSurface-200 text-black rounded-lg"
                            : "text-irGray-600"
                    } dark:text-white`}
                    onClick={() => handleClick("percentage")}
                >
                    <Translate keyName="as-percentage" />
                </div>
                <div
                    data-testid="bulk-resizer-social-media-selector"
                    className={`py-2 flex-grow text-center ${
                        dimensionType === "socialMedia"
                            ? "bg-white dark:bg-darkSurface-200 text-black rounded-lg"
                            : "text-irGray-600"
                    } dark:text-white`}
                    onClick={() => handleClick("socialMedia")}
                >
                    <Translate keyName="social-media" />
                </div>
            </div>
        </div>
    );
};

export default DimensionTypes;
